export const getIdKota = (cities, city) => {
    return cities.filter(item => item.nama === city)
}